const TW_TOKEN_STATUS_INVALID = 2;

/**
 * Whether the stored Triple Whale token was marked invalid (e.g. revoked, caught by the token-validate job).
 * @param {object} [tripleWhaleSettings]
 * @returns {boolean}
 */
export const isApiTokenInvalid = (tripleWhaleSettings) =>
    tripleWhaleSettings?.apiToken?.status === TW_TOKEN_STATUS_INVALID || Boolean(tripleWhaleSettings?.invalidatedAt);

/**
 * Whether a working Triple Whale token is stored (set up by Klickly after the invite).
 * @param {object} [tripleWhaleSettings]
 * @returns {boolean}
 */
export const isApiTokenValid = (tripleWhaleSettings) =>
    Boolean(tripleWhaleSettings?.apiToken) && !isApiTokenInvalid(tripleWhaleSettings);

/**
 * Whether the brand confirmed the Klickly invite and still has no valid token (none, or an invalidated one).
 * @param {object} [tripleWhaleSettings]
 * @returns {boolean}
 */
export const isInviteInProgress = (tripleWhaleSettings) =>
    Boolean(tripleWhaleSettings?.inviteSentAt) && !isApiTokenValid(tripleWhaleSettings);
